<script setup lang="ts">
  import type { HTMLAttributes } from "vue";
  import { cn } from "@/lib/utils";

  const props = defineProps<{
    class?: HTMLAttributes["class"];
  }>();
</script>

<template>
  <ul
    data-slot="sidebar-menu-sub"
    data-sidebar="menu-badge"
    :class="
      cn(
        'border-sidebar-border mx-3 flex min-w-0 translate-x-px flex-col gap-0.5 border-l px-2 py-0.5',
        'group-data-[collapsible=icon]:hidden',
        props.class,
      )
    ">
    <slot />
  </ul>
</template>
